import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    loading,
    message
}) {
    const { t } = useTranslation();

    return (
        <>

            <Modal isOpen={isOpen} toggle={onClose} centered>
                <ModalBody>
                    <div className='py-4 px-2'>
                        <h3 className='main_heading'>
                            {message || t('confirmModal.defaultMessage')}
                        </h3>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" onClick={onConfirm} disabled={loading}>{loading ? t('confirmModal.pleaseWait') : t('confirmModal.yes')}</button>
                    <button className="table_delete" onClick={onClose} disabled={loading}>{t('common.cancel')}</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationModal;